//dependencias
import React, { Component } from 'react';

//componentes
import MontosAction from './montosXTerapias'

class Espera extends Component {

    render(){
        return(
            <div>
                <MontosAction />
            </div>
        );
    }

}
export default Espera;